import React from 'react';
import {connect} from "react-redux";
import {compose} from "recompose";
import {withRouter} from "react-router-dom";
import {SIGN_IN} from "../constants/routes";
import {auth} from "../firebase/index";

/**
 * HOC component to manage authorization states throughout
 * the application as and when needed.
 *
 * @param authorizationFunction to be used to control
 * authentication type for the current authenticated user.
 * This function should return {@code true} if the current
 * user is authorized to access a certain page, or return
 * {@code false} resulting in being routed to some other
 * page otherwise.
 *
 * @param Component to be rendered
 */
const withUserRoleAuthorization = (authorizationFunction) => (Component) => {
    class WithUserRoleAuthorization extends React.Component {
        componentDidMount() {
            // Route the user to sign in page if
            // not authorized to view the page
            auth.doOnAuthStateChanged(authUser => {
                if (!authorizationFunction(authUser)) {
                    this.props.history.push(SIGN_IN);
                }
            });
        }

        render() {
            // render nothing for this component or
            // null if the current user is null.
            return this.props.authUser ? <Component/> : null;
        }
    }

    /**
     * Map Redux {@param state} to component props
     */
    const mapStateToProps = (state) => ({
        authUser: state.sessionState.authUser
    });

    return compose(withRouter, connect(mapStateToProps))(WithUserRoleAuthorization);
};

export default withUserRoleAuthorization;



// WEBPACK FOOTER //
// ./src/components/WithUserRoleAuthorization.jsx